<template>
  <div>
    <div class="container-buttons">
      <div class="container-buttons-start">
        <button
          v-show="this.clients.length > 0"
          class="btn-custom btn-stop-cobranca mb-3"
          @click="cleanQueue"
        >
          <i class="fa fa-ban"></i> Parar processo de ligações
        </button>
        <button
          class="btn-custom btn-info mb-3 ml-2"
          @click="invokeFileInputClick"
        >
          <i class="fa fa-upload"></i> Importar Lista
        </button>
        <button
          v-show="file"
          class="btn-custom btn-cobranca mb-3 ml-2"
          @click="invokeCalls"
        >
          <i class="fa fa-cloud-upload"></i> Adicionar lista na fila
        </button>
        <input
          type="file"
          @change="onSelectFile"
          accept=".csv"
          class="hidden"
          id="fileInput"
        />
      </div>
      <a @click="showConfigModal"
        ><i class="fa fa-cog btn-config mt-2 mr-3"></i
      ></a>
    </div>
    <modal name="config" :adaptive="true" classes="modal-override">
      <p class="text-center mt-1 modal-title">Configurações</p>
      <hr />
      <form @submit.prevent="updateConfig" class="container">
        <div class="row">
          <div class="col-md-12">
            <fg-input
              label="URL de ligação da URA"
              type="url"
              required
              placeholder="https://uracallurl.com.br/clicktocall.php"
              v-model="urlConfig"
            ></fg-input>
          </div>
        </div>
        <div>
          <button class="btn-custom btn-cobranca btn-modal" type="submit" round>
            Salvar
          </button>
        </div>
        <div class="clearfix"></div>
      </form>
    </modal>
    <card
      :title="`Pré-visualização (${fileContent.length})`"
      subTitle="Itens a serem importados"
      v-show="fileContent.length > 0"
    >
      <div slot="raw-content" class="table-responsive">
        <table class="table table-striped">
          <thead>
            <th>ID</th>
            <th>Nome</th>
            <th>CPF</th>
            <th>Bairro</th>
            <th>Telefone</th>
            <th>Ramal</th>
          </thead>
          <tbody>
            <tr v-for="client in paginatedPreview" :key="client.id">
              <td>{{ client.id }}</td>
              <td>{{ client.name || "-" }}</td>
              <td>{{ client.taxId || "-" }}</td>
              <td>{{ client.district || "-" }}</td>
              <td>{{ client.phones.join(",") || "-" }}</td>
              <td>{{ client.branch || "-" }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </card>
    <Pagination
      :currentPage="paginationPreview.currentPage"
      :totalPages="paginationPreview.totalPages"
      v-on:update="updatePaginationPreview"
    />

    <card
      :title="`Itens na fila (${this.clients.length})`"
      subTitle="Itens na fila para ligação automática"
    >
      <div slot="raw-content" class="table-responsive">
        <table class="table table-striped">
          <thead>
            <th>ID</th>
            <th>Nome</th>
            <th>CPF</th>
            <th>Bairro</th>
            <th>Telefone</th>
            <th>Ramal</th>
            <th>Ações</th>
          </thead>
          <tbody>
            <tr v-for="client in paginatedClients" :key="client.data.clientId">
              <td>{{ client.data.clientId }}</td>
              <td>{{ client.data.name || "-" }}</td>
              <td>{{ client.data.taxId || "-" }}</td>
              <td>{{ client.data.district || "-" }}</td>
              <td>{{ client.data.phone || "-" }}</td>
              <td>{{ client.data.branch || "-" }}</td>
              <td>
                <p-button
                  type="warning"
                  outline
                  icon
                  title="Na fila para ligação de cobrança"
                  disabled
                >
                  <i class="fa fa-volume-control-phone"></i>
                </p-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </card>
    <Pagination
      :currentPage="pagination.currentPage"
      :totalPages="pagination.totalPages"
      v-on:update="updatePagination"
    />
  </div>
</template>

<script>
import Swal from "sweetalert2";
import Pagination from "@/components/Pagination.vue";

export default {
  components: {
    Pagination
  },
  computed: {
    paginatedClients() {
      return this.clients.slice(
        (this.pagination.currentPage - 1) * this.pagination.perPage,
        this.pagination.currentPage * this.pagination.perPage
      );
    },
    paginatedPreview() {
      return this.fileContent.slice(
        (this.paginationPreview.currentPage - 1) *
          this.paginationPreview.perPage,
        this.paginationPreview.currentPage * this.paginationPreview.perPage
      );
    }
  },
  data() {
    return {
      file: null,
      fileContent: [],
      clients: [],
      pagination: {
        totalPages: 1,
        currentPage: 1,
        perPage: 20
      },
      paginationPreview: {
        totalPages: 1,
        currentPage: 1,
        perPage: 5
      },
      branchConfig: "0",
      urlConfig: ""
    };
  },
  methods: {
    showConfigModal() {
      this.fetchConfig();
      this.$modal.show("config");
    },
    onSelectFile(evt) {
      const reader = new FileReader();
      reader.onload = () => {
        this.fileContent = this.csvToJson(reader.result).map(r => {
          let phones = [
            r["Tel.1"] ? r["Tel.1"].replace(" ", "") : "",
            r["Tel.2"] ? r["Tel.2"].replace(" ", "") : "",
            r["Tel.3"] ? r["Tel.3"].replace(" ", "") : "",
            r["Tel.4"] ? r["Tel.4"].replace(" ", "") : "",
            r["Tel.5"] ? r["Tel.5"].replace(" ", "") : "",
            r["Tel.6"] ? r["Tel.6"].replace(" ", "") : ""
          ];

          phones = phones.filter(phone => phone);

          return {
            id: +r["Assinante"],
            name: r["Nome do Assinante"],
            taxId: r["C.P.F. / C.N.P.J."],
            district: r["Bairro"],
            branch: r["Ramal"],
            phones
          };
        });

        this.paginationPreview.totalPages = Math.floor(
          (this.fileContent.length - 1) / this.paginationPreview.perPage + 1
        );

        if (this.fileContent.length === 0) {
          Swal.fire({
            title: "Ops!",
            text:
              "Não foi possível concluir esta ação, verifique se o arquivo é válido",
            icon: "error"
          });
          this.clearSelectedFile();
        }
      };
      this.file = evt.target.files[0];
      if (this.file) {
        reader.readAsBinaryString(this.file);
      } else {
        this.fileContent = [];
        this.paginationPreview.totalPages = Math.floor(
          (this.fileContent.length - 1) / this.paginationPreview.perPage + 1
        );
      }
    },
    csvToJson(csv) {
      var lines = csv.split(/\r|\n/);

      var result = [];

      var headers = lines[0].split(";");

      for (var i = 1; i < lines.length; i++) {
        var obj = {};
        var currentline = lines[i].split(";");

        if (currentline.length <= 1) {
          continue;
        }

        for (var j = 0; j < headers.length; j++) {
          obj[headers[j]] = currentline[j];
        }

        result.push(obj);
      }
      return result;
    },
    clearSelectedFile() {
      const input = document.getElementById("fileInput");
      input.value = "";
      this.file = null;
      this.fileContent = [];
      this.paginationPreview.totalPages = Math.floor(
        (this.fileContent.length - 1) / this.paginationPreview.perPage + 1
      );
    },
    invokeFileInputClick() {
      const input = document.getElementById("fileInput");
      const clickEvent = new MouseEvent("click", {
        view: window,
        bubbles: true,
        cancelable: false
      });
      input.dispatchEvent(clickEvent);
    },
    async invokeCalls() {
      const result = await Swal.fire({
        title: "Atenção!",
        text:
          "Esta ação irá adicionar os dados deste arquivo na fila, deseja prosseguir?",
        icon: "warning",
        focusConfirm: false,
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: "#9dcf6b",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim",
        cancelButtonText: "Não"
      });

      if (result.isConfirmed) {
        try {
          await this.$http.post("/queue/batch", this.fileContent, {
            params: { queue: "generic" }
          });
          this.fetchProgress();

          Swal.fire({
            title: "Sucesso!",
            text: "Os pontos foram adicionados a fila de ligações de cobrança",
            icon: "success"
          });
        } catch (err) {
          Swal.fire({
            title: "Ops!",
            text:
              "Não foi possível concluir esta ação, verifique se o arquivo é válido",
            icon: "error"
          });
        }
      }

      this.clearSelectedFile();
    },
    async cleanQueue() {
      const result = await Swal.fire({
        title: "Atenção!",
        text:
          "Esta ação irá parar as ligações de cobrança em andamento, deseja prosseguir?",
        icon: "warning",
        focusConfirm: false,
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: "#9dcf6b",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim",
        cancelButtonText: "Não"
      });

      if (result.isConfirmed) {
        try {
          await this.$http.post("/queue/clean", undefined, {
            params: { queue: "generic" }
          });
          this.clients = [];
          this.pagination.totalPages = Math.floor(
            (this.clients.length - 1) / this.pagination.perPage + 1
          );

          Swal.fire({
            title: "Sucesso!",
            text: "A fila de ligações de cobrança foi cancelada",
            icon: "success"
          });
        } catch (err) {
          Swal.fire({
            title: "Ops!",
            text: "Não foi possível concluir esta ação",
            icon: "error"
          });
        }
      }
    },
    async fetchProgress() {
      const { data } = await this.$http.get("/queue/jobs", {
        params: { queue: "generic" }
      });
      this.clients = data.reverse();
      this.pagination.totalPages = Math.floor(
        (this.clients.length - 1) / this.pagination.perPage + 1
      );
    },
    async fetchConfig() {
      const { data } = await this.$http.get("/config");
      this.urlConfig = data.queueUrl;
    },
    async updateConfig() {
      try {
        await Promise.all([
          this.$http.put("/config", {
            queueUrl: this.urlConfig
          })
        ]);

        Swal.fire({
          title: "Sucesso!",
          text:
            "Valores atualizados, eles serão utilizados para as novas ações.",
          icon: "success"
        });
      } catch (err) {
        Swal.fire({
          title: "Ops!",
          text: "Não foi possível atualizar os valores.",
          icon: "error"
        });
      }
    },
    async updatePaginationPreview({ currentPage }) {
      this.paginationPreview.currentPage = currentPage;
    },
    async updatePagination({ currentPage }) {
      this.pagination.currentPage = currentPage;
    }
  },
  async mounted() {
    try {
      await Promise.all([this.fetchConfig(), this.fetchProgress()]);

      this.fetchProgressInterval = setInterval(
        this.fetchProgress.bind(this),
        10000
      );
    } catch (err) {
      Swal.fire({
        title: "Ops!",
        text: "Não foi possível carregar as informações",
        icon: "error"
      });
    }
  },
  beforeDestroy() {
    clearInterval(this.fetchProgressInterval);
  }
};
</script>

<style lang="scss" scoped>
.hidden {
  display: none;
}
.modal-title {
  font-size: 20px;
}
.btn-modal {
  padding: 10px 60px;
}
.container-body {
  display: flex;

  p {
    font-size: 16px;
  }
}
.container-buttons {
  display: flex;
  justify-content: space-between;

  a {
    cursor: pointer;
  }
}
i.btn-config {
  font-size: 40px;
}
.btn-custom {
  color: #f4f3ef;
  border: none;
  border-radius: 7px;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  padding: 13px 20px;
  transition: all 0.5s;

  &.btn-cobranca {
    background: #9dcf6b;

    &:hover {
      background: #82ac58;
    }
  }

  &.btn-stop-cobranca {
    background: #b80a0a;

    &:hover {
      background: #700202;
    }
  }

  &.btn-modal {
    padding: 10px 50px;
  }
}

.btn-outline-success {
  border-color: #9dcf6b;
  color: #9dcf6b;

  &:hover {
    background: #9dcf6b;
    border-color: #9dcf6b;
  }
}

.btn-outline-warning {
  border-color: #ffc107;
  color: #ffc107;

  &:hover {
    background: #ffc107 !important;
    background-color: #ffc107 !important;
    border-color: #ffc107;
  }
}

.modalPhones {
  ul {
    font-size: 16px;
    li {
      list-style: none;
    }
  }
}
</style>
<style>
@media (max-width: 425px) {
  .modal-override {
    margin: auto;
    max-width: 400px;
    height: 385px !important;
  }
}
</style>
